import { useRef, useState } from "react";
import classes from "./Footer.module.scss";

const Footer = (props) => {
  const emailRef = useRef(null);
  const content = useRef(null);
  const { isDark } = props;
  return (
    <div className={classes.footer}>
      <div className={classes.footer_heading}>Contact</div>
      <div className={classes.footer_wrapper}>
        <input
          type="email"
          ref={emailRef}
          className={classes.footer_input}
          placeholder="Email ID"
          style={{
            color: isDark ? "#fefefe" : "#090916",
            border: isDark
              ? "2px solid rgba(254, 254, 254, 0.212)"
              : "2px solid rgba(9, 9, 22, 0.212)",
          }}
        />
        <textarea
          ref={content}
          cols={4}
          className={classes.footer_textarea}
          placeholder="Your Message..."
          style={{
            color: isDark ? "#fefefe" : "#090916",
            border: isDark
              ? "2px solid rgba(254, 254, 254, 0.212)"
              : "2px solid rgba(9, 9, 22, 0.212)",
          }}
        />
        <div className={classes.footer_button}>Reach Out</div>
      </div>
      <div
        className={[classes.footer_heading, classes.footer_heading_2].join(" ")}
      >
        Social Links
      </div>
      <div className={classes.footer_flex}>
        <a
          href="https://github.com/Deexit1"
          target="_blank"
          className={classes.footer_flex_links}
          style={{ color: isDark ? "#fefefe" : "#090916" }}
        >
          Github
        </a>
        <a
          href="https://linkedin.com/in/deexitpatel"
          target="_blank"
          className={classes.footer_flex_links}
          style={{ color: isDark ? "#fefefe" : "#090916" }}
        >
          LinkedIn
        </a>
        <a
          href="mailto:deexitpatel4@gmail.com"
          target="_blank"
          className={classes.footer_flex_links}
          style={{ color: isDark ? "#fefefe" : "#090916" }}
        >
          Email
        </a>
      </div>
    </div>
  );
};

export default Footer;
